import React from 'react';
import PropTypes from 'prop-types';
import { TableHead, TableRow, TableCell, Typography, makeStyles } from "@material-ui/core";
import t from "../../../languages/pl";
import { themeTypeToBool } from './../../../utils/helpers';

const useStyles = makeStyles(theme => ({
    header: {
        background: themeTypeToBool(theme.palette.type) ? theme.palette.background.default : theme.palette.background.paper,
    },
    cell: {
        textAlign: "center",
        padding: theme.spacing(1)
    },
    pointer: {
        cursor: "pointer"
    }
}));

const CarDetailsHeader = props => {
    const defaultStyles = useStyles();
    const { classes = defaultStyles } = props;

    return (
        <TableHead className={classes.header}>
            <TableRow>
                <TableCell className={classes.cell}>
                    <Typography variant="body1">
                        {t.registrationNo}
                    </Typography>
                </TableCell>
                <TableCell className={classes.cell}>
                    <Typography variant="body1">
                        {t.brand}
                    </Typography>
                </TableCell>
                <TableCell className={classes.cell}>
                    <Typography variant="body1">
                        {t.model}
                    </Typography>
                </TableCell>
                <TableCell className={classes.cell}>
                    <Typography variant="body1">
                        {t.description}
                    </Typography>
                </TableCell>
                <TableCell />
            </TableRow>
        </TableHead>
    );
};

export default CarDetailsHeader;

CarDetailsHeader.propTypes = {
    classes: PropTypes.object
};